<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container"
               @toggleClick="toggleSideBar"/>

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container"/>

    <div class="right-menu">
      <div class="alert-message">
        <el-badge :value="unconfirmedCount" :hidden="unconfirmedCount === 0" class="alert-badge">
          <div class="icon-wrapper" @click="openAlertHistory" style="cursor: pointer;">
            <svg-icon icon-class="note" class="icon-note"></svg-icon>
          </div>
        </el-badge>
      </div>
      <div class="avatar-wrapper">
        <div class="information">
          <p>
            <span data-v-feeabc52="" class="text-name" style="background: rgb(186, 116, 243);">
            A
             </span>
          </p>
        </div>
        <span class="user-name">admin</span>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Breadcrumb from '@/components/Breadcrumb'
  import Hamburger from '@/components/Hamburger'
  import ErrorLog from '@/components/ErrorLog'
  import { getUnconfirmedNotifies } from '@/api/notify'
  import { groupUnconfirmedNotifies } from '@/utils/notify-group'

  export default {
    components: {
      Breadcrumb,
      Hamburger,
      ErrorLog
    },
    data() {
      return {
        unconfirmedCount: 0
      }
    },
    computed: {
      ...mapGetters([
        'sidebar',
        'avatar',
        'device'
      ])
    },
    mounted() {
      this.loadUnconfirmedCount()
      // 每30秒刷新一次未确认数量
      this.refreshTimer = setInterval(() => {
        this.loadUnconfirmedCount()
      }, 30000)
    },
    beforeDestroy() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
      }
    },
    methods: {
      toggleSideBar() {
        this.$store.dispatch('app/toggleSideBar')
      },
      async logout() {
        await this.$store.dispatch('admin/logout')
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      },
      async loadUnconfirmedCount() {
        try {
          const { data } = await getUnconfirmedNotifies()
          this.unconfirmedCount = groupUnconfirmedNotifies(data).length
        } catch (error) {
          console.error('获取未确认数量失败:', error)
        }
      },
      openAlertHistory() {
        this.$router.push('/sys/notify-history')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .navbar {
    height: 50px;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

    .hamburger-container {
      line-height: 46px;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background .3s;
      -webkit-tap-highlight-color: transparent;

      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }

    .breadcrumb-container {
      float: left;
    }

    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }

    .right-menu {
      float: right;
      height: 100%;
      line-height: 50px;
      width: 170px;
      display: flex;
      align-items: center;

      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background .3s;

          &:hover {
            background: rgba(0, 0, 0, .025)
          }
        }
      }

      .avatar-container {
        margin-right: 30px;

        .avatar-wrapper {
          margin-top: 5px;
          position: relative;

          .user-avatar {
            cursor: pointer;
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }

          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }

  .alert-message {
    margin-right: 15px;
    display: flex;
    align-items: center;

    .alert-badge {
      ::v-deep .el-badge__content {
        top: 8px;
        right: 8px;
      }
    }
  }

  .avatar-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    height: 100%;
  }

  .information {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .user-name {
    font-size: 14px;
    color: #222;
    margin-left: 10px;
  }

  .text-name {
    width: 32px;
    height: 32px;
    background: #d8d8d8;
    border-radius: 50%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fefefe;
    font-size: 16px;
  }
</style>
